const CELL_PHONE = 'sms_voice'
const LAND_LINE = 'voice_only'
const EMAIL = 'email'

export const API_TYPE_MAP = {
  [CELL_PHONE]: 'Cellphone',
  [LAND_LINE]: 'Landline',
  [EMAIL]: 'Email'
}

export const MAX_FILESIZE = 100 * 1024 * 1024 // 100MB
